/**
 * @desc 根据交货单单号查询绑定的箱子-分页
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBox.getBoxCodePageListByDono.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBox/getBoxCodePageListByDono`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
